const initialState = {};

export const permissions = (state = initialState, action) => {
  switch (action.type) {
    case 'INITIALIZATION_DATA': {
      return {
        ...state,
        ...(action.data.permissions || {}),
      };
    }
    case 'permissions/INITIALIZE': {
      return {
        ...state,
        ...action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
